/**
 * @generated SignedSource<<87cc1f4248c594f5756f3ff77cc9fd8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudStorageProvider = "GOOGLE_DRIVE" | "ONEDRIVE" | "%future added value";
export type IssueCloudPickerTokenInput = {
  provider: CloudStorageProvider;
  resource?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type cloudProviderQueriesPickerTokenMutation$variables = {
  input: IssueCloudPickerTokenInput;
};
export type cloudProviderQueriesPickerTokenMutation$data = {
  readonly issueCloudPickerToken: {
    readonly accessToken: string;
    readonly expiresAt: string;
  } | null;
};
export type cloudProviderQueriesPickerTokenMutation = {
  variables: cloudProviderQueriesPickerTokenMutation$variables;
  response: cloudProviderQueriesPickerTokenMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IssueCloudPickerTokenPayload",
    "kind": "LinkedField",
    "name": "issueCloudPickerToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cloudProviderQueriesPickerTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cloudProviderQueriesPickerTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1cc7ddae69a625fb5c976aeeed321025",
    "id": null,
    "metadata": {},
    "name": "cloudProviderQueriesPickerTokenMutation",
    "operationKind": "mutation",
    "text": "mutation cloudProviderQueriesPickerTokenMutation(\n  $input: IssueCloudPickerTokenInput!\n) {\n  issueCloudPickerToken(input: $input) {\n    accessToken\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "e37517c0f36fac9ebaafb329dfa7320d";

export default node;
